"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const FieldName_1 = __importDefault(require("./FieldName"));
const BasicValue_1 = __importDefault(require("./BasicValue"));
exports.useStyles = (0, mui_1.makeStyles)()({
    field: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});
function SimpleField({ name, value, description, prefix, width, }) {
    const { classes } = (0, exports.useStyles)();
    return value !== null && value !== undefined ? (react_1.default.createElement("div", { className: classes.field },
        react_1.default.createElement(FieldName_1.default, { prefix: prefix, description: description, name: name, width: width }),
        react_1.default.createElement(BasicValue_1.default, { value: value }))) : null;
}
exports.default = SimpleField;
